import { createUseStyles } from 'react-jss';

export default createUseStyles({
  loadingContainer: {
    top: 0,
    left: 0,
    zIndex: 10,
    width: '100%',
    height: '100%',
    position: 'absolute',
    background: 'rgba(0,0,0,0.05)',
  },
  transparent: {
    background: 'none',
  },
  centered: {},
  relativePosition: {
    position: 'relative',
  },
  loading: {
    left: '50%',
    top: '200px',
    textAlign: 'center',
    position: 'absolute',
    transform: 'translateX(-50%)',

    '$centered &': {
      top: '50%',
      transform: 'translate(-50%, -50%)',
    },
  },
});
